/**
 * Throws an error with a message indicating that an unknown object was encountered.
 * @param {never} x - The unknown object.
 * @param {string} [filename=''] - The name of the file where the error occurred.
 * @throws {Error} - Always throws an error.
 * @returns {never} - This function never returns a value.
 */
export const assertNever = (x: never, filename: string = ''): never => {
  throw new Error(`${filename} | Unknown object ${JSON.stringify(x, null, 2)}`);
};
